import { CountryEnv } from "@type/country";

const _countryEnv: CountryEnv = {
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_EU_UQ || "",
  firebaseMeasurementId: "",
  faqUrl: "https://faq-be.uniqlo.com/"
};

export default _countryEnv;
